// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
interface ImportedModule {
  name: string
  default: object
}
const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
  eager: true,
})

import { createApp } from 'vue'
const app = createApp({})

for (const path in vueSingleFileComponents) {
  const importedModule = vueSingleFileComponents[String(path)]
  const name = path.split('/').pop()?.split('.')[0]
  if (name !== undefined && typeof name === 'string') {
    app.component(name, importedModule.default)
  }
}
if (document.querySelector('#vue-app')) {
  app.mount('#vue-app')
} else {
  console.info('No "#vue-app"')
}

/**
 * 🦄: Now do your magic.
 */

import Plyr from 'plyr'

import VideoPlayer from './Components/VideoPlayer.js'
import SpeakersSearch from './Components/SpeakersSearch.js'
import VideoSearch from './Components/VideoSearch.js'
import initMegaMenu from './Components/megaMenu.js'
import initMobileMenu from './Components/mobileMenu.js'
import initHeaderHeightVar from './Components/headerHeight.js'
import initHeroVideo from './Components/heroVideo.js'

document.addEventListener('DOMContentLoaded', () => {
  initHeaderHeightVar()
  VideoPlayer(Plyr)
  SpeakersSearch()
  VideoSearch()
  initMegaMenu()
  initMobileMenu()
  initHeroVideo()
})

let words = document.getElementsByClassName('animated-word')
let wordArray = []
let currentWord = 0
if (words.length > 0) {
  words[currentWord].style.opacity = 1
  for (let i = 0; i < words.length; i++) {
    splitLetters(words[i])
  }
}

function changeWord() {
  let cw = wordArray[currentWord]
  let nw = currentWord == words.length - 1 ? wordArray[0] : wordArray[currentWord + 1]
  for (let i = 0; i < cw.length; i++) {
    animateLetterOut(cw, i)
  }

  for (let i = 0; i < nw.length; i++) {
    nw[i].className = 'letter behind'
    nw[0].parentElement.style.opacity = 1
    animateLetterIn(nw, i)
  }

  currentWord = currentWord == wordArray.length - 1 ? 0 : currentWord + 1
}

function animateLetterOut(cw, i) {
  setTimeout(function () {
    cw[i].className = 'letter out'
  }, i * 80)
}

function animateLetterIn(nw, i) {
  setTimeout(
    function () {
      nw[i].className = 'letter in'
    },
    340 + i * 80
  )
}

function splitLetters(word) {
  let content = word.innerHTML
  word.innerHTML = ''
  let letters = []
  for (let i = 0; i < content.length; i++) {
    let letter = document.createElement('span')
    letter.className = 'letter'
    letter.innerHTML = content.charAt(i)
    word.appendChild(letter)
    letters.push(letter)
  }

  wordArray.push(letters)
}

if (words.length > 0) {
  changeWord()
  setInterval(changeWord, 4000)
}

function updateQueryStringParameter(uri: string, key: string, value: string) {
  let url = new URL(uri, window.location.origin)
  if (value && value !== '') {
    url.searchParams.set(key, value)
  } else {
    url.searchParams.delete(key)
  }
  // Remove duplicate params and return clean URL
  return url.pathname + (url.search ? url.search : '')
}

const termFilter = document.getElementById('term-filter')
if (termFilter) {
  termFilter.addEventListener('change', function () {
    const termId = this.value
    let url = updateQueryStringParameter(window.location.href, 'term', termId)
    url = updateQueryStringParameter(url, 'paged', '1')
    location.href = url
  })
}

const yearFilter = document.getElementById('year-filter')
if (yearFilter) {
  yearFilter.addEventListener('change', function () {
    const year = this.value
    let url = updateQueryStringParameter(window.location.href, 'y', year)
    url = updateQueryStringParameter(url, 'paged', '1')
    location.href = url
  })
}

//accordions

const accordions = document.querySelectorAll('#js-accordion')

const openAccordion = (accordion) => {
  const content = accordion.querySelector('.js-accordion-content')
  accordion.classList.add('active')
  content.classList.remove('opacity-0')
  content.style.maxHeight = content.scrollHeight + 'px'
}

const closeAccordion = (accordion) => {
  const content = accordion.querySelector('.js-accordion-content')
  accordion.classList.remove('active')
  content.style.maxHeight = null
}

accordions.forEach((accordion) => {
  const intro = accordion.querySelector('.js-accordion-intro')
  const content = accordion.querySelector('.js-accordion-content')

  intro.onclick = () => {
    if (content.style.maxHeight) {
      closeAccordion(accordion)
    } else {
      accordions.forEach((accordion) => closeAccordion(accordion))
      openAccordion(accordion)
    }
  }
})
